import { render, staticRenderFns } from "./AccountCancellationConfirmation.vue?vue&type=template&id=2df1e46f&scoped=true"
import script from "./AccountCancellationConfirmation.vue?vue&type=script&lang=ts"
export * from "./AccountCancellationConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./AccountCancellationConfirmation.vue?vue&type=style&index=0&id=2df1e46f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df1e46f",
  null
  
)

export default component.exports